namespace app.support.suggestion {
    'use strict';
    
    angular
        .module('app.support.suggestion', ['app.support.constants']);
}